export default class TransferStudentService {
  constructor(http) {
    this.http = http;
  }

  async findAllTransferStudent(conditions = {}) {
    const queryParams = Object.entries(conditions)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");
    return this.http.fetch(`/api/transferstudent/readall?${queryParams}`, {
      method: "GET",
    });
  }

  async findAllTransferStudentByFlexibleDataId(conditions = {}) {
    const queryParams = Object.entries(conditions)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");
    return this.http.fetch(
      `/api/transferstudent/readallbyflexibledataid?${queryParams}`,
      {
        method: "GET",
      }
    );
  }

  async createTransferStudent(data) {
    return this.http.fetch(`/api/transferstudent/create`, {
      method: "POST",
      body: JSON.stringify(data),
    });
  }

  async updateTransferStudent(data) {
    return this.http.fetch(`/api/transferstudent/update`, {
      method: "PUT",
      body: JSON.stringify(data),
    });
  }

  async deleteTransferStudent(id) {
    return this.http.fetch(`/api/transferstudent/delete`, {
      method: "DELETE",
      body: JSON.stringify({ id }),
    });
  }
}
